export default "__VITE_ASSET__DlOSM$az__"